import { EProjectSection, trackEventV2 } from '../trackEventV2';
import {
  ETripsEventName,
  IClaimsCarouselViewedEventInfo,
  IRenterBookingEpisodicUpdatedEventInfo,
} from './types';

export const trackClaimsCarouselOpenedEvent = () => {
  trackEventV2(ETripsEventName.CLAIMS_CAROUSEL_OPENED, EProjectSection.MARKETPLACE, {});
};

export const trackClaimsCarouselViewedEvent = (event: IClaimsCarouselViewedEventInfo) => {
  trackEventV2(ETripsEventName.CLAIMS_CAROUSEL_VIEWED, EProjectSection.MARKETPLACE, { ...event });
};

export const trackRenterBookingEpisodicUpdatedEvent = (
  event: IRenterBookingEpisodicUpdatedEventInfo,
) => {
  trackEventV2(ETripsEventName.RENTER_BOOKING_EPISODIC_UPDATED, EProjectSection.MARKETPLACE, {
    ...event,
  });
};
